<template>
  <div class="">
    <div class="neiye_banner">
      <BANNER></BANNER>
    </div>
    <div class="main">
      <div class="container">
        <div class="location">
          <router-link to="/">网站首页</router-link>
          <router-link to="/yygk">&nbsp;&gt;&nbsp;医院概况</router-link>
          <router-link to="/yygk/lianmeng"
            >&nbsp;&gt;&nbsp;盛京医疗联盟</router-link
          ><span>&nbsp;&gt;&nbsp;盛京医疗联盟章程</span>
        </div>
        <div class="tv_main clearfix">
          <div class="sjjj_main_left fl">
            <SLIDE></SLIDE>
          </div>
          <div class="sjhy_main_right fr">
            <ARTICLE
              :current="current"
              :before="before"
              :after="after"
              :showBeforeAfter="showBeforeAfter"
              :showorigin="showorigin"
              @changePage="handleChangePage"
            ></ARTICLE>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import service from "../../service/yygk";
import BANNER from "../../components/banner/yygk";
export default {
  name: "LIANMENGARTICLE",
  data() {
    return {
      current: {},
      // 上一篇
      before: {
        title: "",
        id: "",
        active: false,
      },
      // 下一篇
      after: {
        title: "",
        id: "",
        active: false,
      },
      showBeforeAfter: true, //是否显示上一篇 下一篇
      showorigin: false, //是否显示来源 发布时间 点击次数
    };
  },
  components: {
    BANNER,
  },
  computed: {},
  created() {
    this.init();
  },
  beforeMount() {},
  methods: {
    init() {
      let parmes = {
        id: this.$route.query.id,
      };
      service.getHosOverviewUnionInfo(parmes, (res) => {
        res.current.releaseDate = res.current.releaseDate
          ? res.current.releaseDate.split(" ")[0]
          : "";
        this.current = { ...res.current };
        if (res.before) {
          this.before = { ...res.before };
          this.before.active = true;
        } else {
          this.before.title = "已经没有上一篇";
          this.before.active = false;
        }
        if (res.after) {
          this.after = { ...res.after };
          this.after.active = true;
        } else {
          this.after.title = "已经没有下一篇";
          this.after.active = false;
        }
      });
    },
    // 上一篇 下一篇
    handleChangePage(id) {
      const query = JSON.parse(JSON.stringify(this.$route.query)); // 获取路由参数信息
      query.id = id; //改变参数
      this.$router.push({ path: this.$route.path, query }); //更新路由
      this.init();
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style>
</style>
